import { render, staticRenderFns } from "./CmgFeedbackModal.vue?vue&type=template&id=57735352&scoped=true&lang=pug&"
import script from "./cmg-feedback-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-feedback-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgFeedbackModal.vue?vue&type=style&index=0&id=57735352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57735352",
  null
  
)

export default component.exports